'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _sharingPopupConstants = require('./sharingPopupConstants');

var _popupConstants = require('../../../../components/popupPanel/popupConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
var initialState = Immutable.Map({
    showShareForm: false
}); // Lib

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _sharingPopupConstants.SHARE_POPUP_TOGGLE_SHARE_FORM:
            return state.set('showShareForm', !state.get('showShareForm'));
        case _popupConstants.POPUP_OPEN:
        case _popupConstants.POPUP_CLOSE:
        case _popupConstants.POPUP_TOGGLE:
            if (action.popupId !== 'sharing') return state;
            return initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/sharingPopupReducer.js
// module id = 2196
// module chunks = 0